import { render, staticRenderFns } from "./CronogramaMidiasSociais.vue?vue&type=template&id=7f248de7"
import script from "./CronogramaMidiasSociais.vue?vue&type=script&lang=js"
export * from "./CronogramaMidiasSociais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports